import React from 'react';
import MobileApp from './MobileApp';

export default <MobileApp />;
